/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import React, { useEffect } from 'react';

import styled from 'styled-components';

const PaypalDiv = styled.div`
  width: 20em;
  position: relative;
  margin-left: 20px;
  z-index: 1;
  -webkit-appearance: none;
  -webkit-border-radius: 0px;
  border-radius: 0px;
`;

interface PayPalButtonProps {
  drJsLibrary: any;
  viewer: {
    firstName: string;
    lastName: string;
    contactEmail: string;
    primaryPhoneNumber: string;
  };
  partnerAccount: {
    name: string;
    contactEmail: string;
    primaryPhoneNumber: string;
  };
  setPayPalSourceData: any;
  setIsPayPalEnabled: any;
  values?: any;
}

const Paypal = (props: PayPalButtonProps) => {
  const {
    drJsLibrary,
    partnerAccount,
    viewer,
    setPayPalSourceData,
    setIsPayPalEnabled,
  } = props;
  const order =
    localStorage.getItem('checkoutDetails') &&
    localStorage.getItem('checkoutDetails') !== 'undefined'
      ? JSON.parse(localStorage.getItem('checkoutDetails') || '')
      : {};
  const isDevelopEnvironment =
    process.env.REACT_APP_ENVIRONMENT !== 'production';
  const items = order?.lineItems?.map(element => {
    return {
      name: element.name,
      quantity: element.quantity,
      unitAmount: element.orderPrice,
    };
  });

  const paypalSourceData = {
    type: 'payPalBilling',
    amount: order?.total?.amount,
    currency: order?.total?.currencyCode,
    payPalBilling: {
      returnUrl: window.location.href,
      cancelUrl: window.location.href,
      items: [...items],
      taxAmount: order?.tax?.amount,
      shippingAmount: order?.totalShipping?.amount,
      amountsEstimated: true,
      shipping: {
        recipient: `${order?.shipTo?.firstName ?? viewer.firstName}  ${order
          ?.shipTo?.lastName ?? viewer.lastName}`,
        firstName: order?.shipTo?.firstName ?? viewer?.firstName ?? '',
        lastName: order?.shipTo?.lastName ?? viewer?.lastName ?? '',
        email: partnerAccount?.contactEmail ?? viewer?.contactEmail ?? '',
        phoneNumber:
          partnerAccount.primaryPhoneNumber ??
          viewer.primaryPhoneNumber ??
          '000-000-0000',
        organization: order?.shipTo?.organization ?? partnerAccount?.name ?? '',
        address: {
          line1: order?.shipTo?.address.addressLine1,
          line2: order?.shipTo.address.addressLine1,
          city: order?.shipTo.address.city,
          state: order?.shipTo.address.stateProvinceRegionCode,
          postalCode: order?.shipTo.address.zipPostalCode,
          country: order?.shipTo.address.countryCode,
        },
      },
    },
  };

  useEffect(() => {
    let paypalSourceId;
    const { paypal } = window as any;
    paypal.Button.render(
      {
        env: isDevelopEnvironment ? 'sandbox' : 'production',
        locale: 'en_US',
        style: {
          label: 'paypal',
          size: 'responsive',
          color: 'gold',
          shape: 'rect',
          layout: 'horizontal',
          tagline: 'false',
        },
        funding: {
          allowed: [paypal.FUNDING.CARD],
          disallowed: [paypal.FUNDING.CREDIT],
        },
        // Set up a payment
        payment: function(data, actions) {
          return drJsLibrary
            ?.createSource(paypalSourceData)
            .then(function(result) {
              if (result.error) {
                alert(result.error);
              } else {
                paypalSourceId = result.source.id;
                setPayPalSourceData(prev => ({
                  ...prev,
                  result,
                }));

                return result.source.payPalBilling.token;
              }
            });
        },
        // Execute the payment
        onAuthorize: function(data, actions) {
          setPayPalSourceData(prev => ({
            ...prev,
            isAuthorize: true,
          }));
          setIsPayPalEnabled(false);
        },
        onCancel: function(data, actions) {
          setIsPayPalEnabled(false);
          console.log('cancelled paypal');
        },
      },
      '#paypal-button'
    );
  }, []);
  return <PaypalDiv id='paypal-button'></PaypalDiv>;
};

export default Paypal;
